module.exports = __webpack_public_path__ + "img/logo.d7490070.gif";